import React, { useState, useEffect } from 'react';
import { Typography, TextField, Button, CircularProgress, Paper, useMediaQuery, IconButton, InputAdornment } from "@material-ui/core";
//import { useNotify } from "react-admin";
import { customTheme } from './customTheme';
import { useHistory } from "react-router-dom";
import config from './config.json';

import md5 from 'md5';
import { passwordSalt } from "./sharedData";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import EditIcon from '@material-ui/icons/Edit';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';


export default function UpdateParkingProfileUser(props) {
    //const notify = useNotify();
    const navigate = useHistory()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [name, setName] = useState("")
    const [displayName, setDisplayName] = useState("")
    const [emailAddress, setEmailAddress] = useState("")
    const [mobile, setMobile] = useState("")
    const [loading, setLoading] = useState("")
    const [pageLoading, setPageLoading] = useState("")

    const [editPassword, setEditPassword] = useState(false)
    const [currentPassword, setCurrentPassword] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [editPrivacyPassword, setEditPrivacyPassword] = useState(false)
    const [privacyPassword, setPrivacyPassword] = useState("");
    const [showPrivacyPassword, setShowPrivacyPassword] = useState(false);
    const [confirmPrivacyPassword, setConfirmPrivacyPassword] = useState("");
    const [showConfirmPrivacyPassword, setShowConfirmPrivacyPassword] = useState(false);


    const getUserInfo = () => {
        setPageLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/user/profile/info`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setName(json.data.name)
                    setDisplayName(json.data.display_name)
                    setEmailAddress(json.data.email)
                    setMobile(json.data.mobile)
                    setPageLoading(false)
                } else {
                    notify(json.message, "info");
                    setPageLoading(false)
                }
            })
            .catch(e => {
                setPageLoading(false)
                notify("Check your internet connection", "warning");
            });
    }

    const updateUserInfo = () => {

        let emailRegex = /\S+@\S+\.\S+/;
        if (name === "" || name == null) {
            return notify("Name is Required", "warning")
        }
        if (displayName === "" || displayName == null) {
            return notify("Display Name is Required", "warning")
        }
        if (emailAddress === "" || emailAddress == null) {
            return notify("Email is Required", "warning")
        }
        if (!emailRegex.test(emailAddress)) {
            return notify("Invalid email address.", "warning")
        }
        if (mobile === "" || mobile == null) {
            return notify("Mobile NUmber is Required", "warning")
        }
        if (mobile.length === 0 || mobile.length < 10) {
            return notify("Invalid mobile number", "warning")
        }

        if (editPassword) {
            if (currentPassword == null || currentPassword === "") {
                notify("Current Password cannot be empty", "warning");
                return;
            }
            if (newPassword == null || newPassword === "") {
                notify("New Password cannot be empty", "warning");
                return;
            }
            if (confirmPassword !== newPassword) {
                notify("Confirm Password does not match New Password", "warning");
                return;
            }
        }

        if (editPrivacyPassword) {
            if (privacyPassword == null || privacyPassword === "") {
                notify("New Password cannot be empty", "warning");
                return;
            }
            if (confirmPrivacyPassword !== privacyPassword) {
                notify("Confirm Password does not match New Password", "warning");
                return;
            }
        }

        let params = {
            name: name,
            display_name: displayName,
            email: emailAddress,
            mobile: mobile
        }
        if (editPassword) {
            params.editPassword = editPassword
            params.current_password = md5(currentPassword + passwordSalt)
            params.new_password = md5(newPassword + passwordSalt)
        }
        if (editPrivacyPassword) {
            params.editPrivacyPassword = editPrivacyPassword
            params.privacy_password = md5(privacyPassword + passwordSalt)
        }

        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/user/profile/info`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    sessionStorage.setItem('display_name', displayName);
                    sessionStorage.setItem('full_name', name);
                    sessionStorage.setItem('email', emailAddress);
                    sessionStorage.setItem('mobile', mobile);
                    notify(json.message, "success");
                    setLoading(false)
                    navigate.push('/parking/profile')
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false);
                notify("Something Went Wrong", "warning");
            });
    }


    useEffect(() => {
        getUserInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <Paper style={{ padding: isSmallDevice ? "0 22px 25px" : "25px 22px", boxShadow: isSmallDevice ? "none" : undefined }}>

            <div style={{ borderBottom: "1px solid #ddd", alignItems: "center", paddingBottom: 15, marginBottom: 20, textAlign: "center" }}>
                <Typography>Update Profile</Typography>
            </div>
            {
                pageLoading ? <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} /> :
                    <div>

                        <TextField
                            className='changePasswordTextField'
                            variant="outlined"
                            size="small"
                            label="Name"
                            value={name}
                            onChange={event => setName(event.target.value)}
                            style={{ display: "block", marginBottom: 20 }}
                        />
                        <TextField
                            className='changePasswordTextField'
                            variant="outlined"
                            size="small"
                            label="Display Name"
                            value={displayName}
                            onChange={event => setDisplayName(event.target.value)}
                            style={{ display: "block", marginBottom: 20 }}
                        />
                        <TextField
                            className='changePasswordTextField'
                            variant="outlined"
                            size="small"
                            label="Email"
                            value={emailAddress}
                            onChange={event => setEmailAddress(event.target.value)}
                            style={{ display: "block", marginBottom: 20 }}
                        />
                        <TextField
                            className='changePasswordTextField'
                            variant="outlined"
                            size="small"
                            label="Mobile"
                            value={mobile}
                            onChange={event => setMobile(event.target.value)}
                            style={{ display: "block", marginBottom: 20 }}
                        />

                        <EditPasswordField editPassword={editPassword} setEditPassword={setEditPassword} currentPassword={currentPassword} setCurrentPassword={setCurrentPassword} showCurrentPassword={showCurrentPassword} setShowCurrentPassword={setShowCurrentPassword} newPassword={newPassword} setNewPassword={setNewPassword} showNewPassword={showNewPassword} setShowNewPassword={setShowNewPassword} confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} showConfirmPassword={showConfirmPassword} setShowConfirmPassword={setShowConfirmPassword} />
                        <EditPrivacyPasswordField editPrivacyPassword={editPrivacyPassword} setEditPrivacyPassword={setEditPrivacyPassword} privacyPassword={privacyPassword} setPrivacyPassword={setPrivacyPassword} confirmPrivacyPassword={confirmPrivacyPassword} setConfirmPrivacyPassword={setConfirmPrivacyPassword} showPrivacyPassword={showPrivacyPassword} setShowPrivacyPassword={setShowPrivacyPassword} showConfirmPrivacyPassword={showConfirmPrivacyPassword} setShowConfirmPrivacyPassword={setShowConfirmPrivacyPassword} />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={updateUserInfo}
                            style={{ textTransform: "none", display: "block" }}
                            disableElevation
                        >
                            {loading ? "Updating..." : "Update"}
                            {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                        </Button>
                    </div>
            }
        </Paper >
    );
}

const EditPasswordField = ({ editPassword, setEditPassword, currentPassword, setCurrentPassword, showCurrentPassword, setShowCurrentPassword, newPassword, setNewPassword, showNewPassword, setShowNewPassword, confirmPassword, setConfirmPassword, showConfirmPassword, setShowConfirmPassword }) => {
    return <>
        <Button startIcon={<EditIcon />} onClick={() => setEditPassword((prev) => !prev)} style={{ width: 180, marginBottom: 15, color: editPassword ? "#18cc69" : "#B5B5B5" }}>Edit Password</Button>

        {
            editPassword &&
            <>
                <TextField
                    className='changePasswordTextField'
                    type={showCurrentPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Current Password"
                    value={currentPassword}
                    onChange={event => setCurrentPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                edge="end"
                            >
                                {showCurrentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <TextField
                    className='changePasswordTextField'
                    type={showNewPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="New Password"
                    value={newPassword}
                    onChange={event => setNewPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowNewPassword(!showNewPassword)}
                                edge="end"
                            >
                                {showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <TextField
                    className='changePasswordTextField'
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Confirm Password"
                    value={confirmPassword}
                    onChange={event => setConfirmPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                edge="end"
                            >
                                {showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
            </>
        }
    </>
}

const EditPrivacyPasswordField = ({ editPrivacyPassword, setEditPrivacyPassword, privacyPassword, setPrivacyPassword, confirmPrivacyPassword, setConfirmPrivacyPassword, showPrivacyPassword, setShowPrivacyPassword, showConfirmPrivacyPassword, setShowConfirmPrivacyPassword }) => {
    return <div>
        <Button startIcon={<EditIcon />} onClick={() => setEditPrivacyPassword((prev) => !prev)} style={{ marginBottom: 15, color: editPrivacyPassword ? "#18cc69" : "#B5B5B5" }}>Edit Privacy Password</Button>

        {
            editPrivacyPassword &&
            <>
                <TextField
                    className='changePasswordTextField'
                    type={showPrivacyPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Privacy Password"
                    value={privacyPassword}
                    onChange={event => setPrivacyPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowPrivacyPassword(!showPrivacyPassword)}
                                edge="end"
                            >
                                {showPrivacyPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <TextField
                    className='changePasswordTextField'
                    type={showConfirmPrivacyPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Confirm Privacy Password"
                    value={confirmPrivacyPassword}
                    onChange={event => setConfirmPrivacyPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowConfirmPrivacyPassword(!showConfirmPrivacyPassword)}
                                edge="end"
                            >
                                {showConfirmPrivacyPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
            </>
        }
    </div>
}